import React from 'react'
import {Box} from 'grommet'
import AccountForm from '../../../components/accountForm'
import { API,Auth } from 'aws-amplify';
import { NavigationSnackBar,ReturnAddress } from '../../../components/utils/shared/shared';

class CreateLab extends React.Component {
    state = {
        load: false,
        value: {organisation: {departments: []}, department_ids: [], lab_departments: [], name: '', primary_contact_person: '',primary_contact_email: '', primary_contact_phone: '',address:{AddressLineOne: '', AddressLineTwo: '',AddressLineThree: '',City: '',PostCode: '',Country: ''}, Country: {CountryCode: ""},country: {CountryCode: ""}},
        org: {name: '', departments: []}
    }
    handleValueChange = (event) => {
        this.setState({value: event});
      };
    handleSubmit = () => {
        this.setState({load: true})
        const lab = ReturnAddress(this.state.value, 'lab', 'create')
        Auth.currentSession().then(session => {
          API
          .post("LabShip", "/labs",
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{lab: lab}})
          .then(shipment => {
           this.setState({load: false})
           this.props.history.push({pathname:'/admin/labs/all', edit:false, labSucc: true})
         })
        })
      }

      handleOrgChange = (event) => {
        this.setState({org: event})
      }
    
    render(){
        const {load,value,org} = this.state;
        return ( 
          <Box>
             <NavigationSnackBar title={'Create Lab'} user={this.props.user} pages={[{name: 'Dashboard',link: '/dashboard'},{name: 'Labs', link: '/labs/all'}]}  />
              <Box direction='row' alignSelf='center' elevation='medium' round>
                  <AccountForm label={"Create Lab"} setOrg={this.handleOrgChange} org={org} user={this.props.user} handleSubmit={this.handleSubmit} setAccount={this.handleValueChange} account={value} load={load} />
              </Box>
            </Box>
          )
    }
}

export default CreateLab
